class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('.slider__slide');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

    // Auto-rotate functionality
    this.autoplayEnabled = this.slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.slider.dataset.speed) || 5000;
    
    if (this.autoplayEnabled) {
      this.autoplayInterval = setInterval(() => {
        this.onButtonClick({ currentTarget: { name: 'next' } });
      }, this.autoplaySpeed);
      
      // Pause on hover
      this.addEventListener('mouseenter', this.pauseAutoplay.bind(this));
      this.addEventListener('mouseleave', this.resumeAutoplay.bind(this));
      
      // Pause on focus within
      this.addEventListener('focusin', this.pauseAutoplay.bind(this));
      this.addEventListener('focusout', this.resumeAutoplay.bind(this));
    }
  }

  initPages() {
    if (!this.sliderItems.length) return;
    
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth);
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    
    if (this.pageTotal) this.pageTotal.textContent = this.totalPages;
    
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    
    const currentScrollLeft = this.slider.scrollLeft;
    const slideWidth = this.sliderItems[0].clientWidth;
    const currentPage = Math.round(currentScrollLeft / slideWidth) + 1;
    
    this.pageCount.textContent = Math.min(currentPage, this.totalPages);
    
    // Update button states
    if (this.prevButton) {
      this.prevButton.disabled = currentPage <= 1;
    }
    
    if (this.nextButton) {
      this.nextButton.disabled = currentPage >= this.totalPages;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    
    const slideWidth = this.sliderItems[0].clientWidth;
    const slidesPerPage = Math.floor(this.slider.clientWidth / slideWidth);
    const slideScrollPosition = event.currentTarget.name === 'next' 
      ? this.slider.scrollLeft + slideWidth * slidesPerPage
      : this.slider.scrollLeft - slideWidth * slidesPerPage;
    
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: 'smooth'
    });
  }
  
  pauseAutoplay() {
    if (this.autoplayEnabled && this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
    }
  }
  
  resumeAutoplay() {
    if (this.autoplayEnabled) {
      this.autoplayInterval = setInterval(() => {
        this.onButtonClick({ currentTarget: { name: 'next' } });
      }, this.autoplaySpeed);
    }
  }
}

customElements.define('slider-component', SliderComponent);
